import { defineMessages } from 'react-intl';

export default defineMessages({
  button: {
    id: 'pages.scorecards.createScorecard.button',
    defaultMessage: 'Create Scorecard',
  },
  title: {
    id: 'pages.scorecards.createScorecard.title',
    defaultMessage: 'Create Scorecard',
  },
  selectReviewCycle: {
    id: 'pages.scorecards.createScorecard.selectReviewCycle',
    defaultMessage: 'Select Review Cycle to assign new Scorecard',
  },
  creationMethod: {
    id: 'pages.scorecards.createScorecard.creationMethod',
    defaultMessage: 'Creation method',
  },
  fromScratch: {
    id: 'pages.scorecards.createScorecard.fromScratch',
    defaultMessage: 'Create from Scratch',
  },
  fromScratchHint: {
    id: 'pages.scorecards.createScorecard.fromScratchHint',
    defaultMessage: 'Start with one empty goal and subgoal',
  },
  cloneFromExisting: {
    id: 'pages.scorecards.createScorecard.cloneFromExisting',
    defaultMessage: 'Clone from Existing',
  },
  cloneFromExistingHint: {
    id: 'pages.scorecards.createScorecard.cloneFromExistingHint',
    defaultMessage: 'Copy the goal structure of one of your scorecards',
  },
  scorecardsList: {
    id: 'pages.scorecards.createScorecard.scorecardsList',
    defaultMessage: 'Scorecards list',
  },
  cloneEmptyState: {
    id: 'pages.scorecards.createScorecard.cloneEmptyState',
    defaultMessage: 'You have no scorecards to clone from yet.',
  },
  cloneNote: {
    id: 'pages.scorecards.createScorecard.cloneNote',
    defaultMessage:
      'Goals, subgoals, weights, settings and reviewers are copied. Feedback,' +
      ' comments and self-assessments are not.',
  },
  create: {
    id: 'pages.scorecards.createScorecard.create',
    defaultMessage: 'Create',
  },
});
